import type { Location } from "@/types/location";

/**
 * Creating a concept with an address also creates one location for it, named
 * `<concept> HQ` and stamped with this code (`companies.service.ts`). Nothing
 * else in the product writes this code, so it is the only marker that tells an
 * auto-provisioned headquarters apart from a location someone added by hand.
 */
export const HEADQUARTERS_LOCATION_CODE = "HQ";

export function isHeadquartersLocation(location: Pick<Location, "code">): boolean {
  return location.code === HEADQUARTERS_LOCATION_CODE;
}
